import { useState, useRef, MutableRefObject, Dispatch, SetStateAction, useCallback } from 'react'


export const useStateRef = <T>(initValue: T): [MutableRefObject<T>, Dispatch<SetStateAction<T>>, T] => {
  const [state, setState] = useState<T>(initValue)
  const stateRef = useRef(initValue)
  stateRef.current = state
  return [stateRef, setState, state]
}

export const useStateSafe = <T>(initValue: T, destroyRef: MutableRefObject<boolean>): [T, Dispatch<SetStateAction<T>>] => {
  const [state, setState] = useState<T>(initValue)
  const setSafe = useCallback((nextState: T) => {
    if (destroyRef.current) {
      return
    }
    setState(nextState)
  }, [destroyRef])
  return [state, setSafe]
}
